/**
 * The value of this annotation is the Okta username of the manager of an AWS account, according
 * to ServiceNow
 *
 * @public
 */
export const AWS_MANAGER_NAME_ANNOTATION = 'cfa/aws-account-manager-name';

/**
 * The value of this annotation is the Okta username of the owner of an AWS account, according
 * to ServiceNow
 *
 * @public
 */
export const AWS_ACCOUNT_NUMBER_ANNOTATION = 'cfa/aws-account-number';


/**
 * The value of this annotation is the Okta username of the owner of an AWS account, according
 * to ServiceNow
 *
 * @public
 */
export const AWS_OWNER_NAME_ANNOTATION = 'cfa/aws-account-owner-name';
